// src/components/pages/sports/Sports.jsx
import React, { useEffect, useState } from "react";
import api from "../../../../api";
import './Sports.css';

import DynamicBanner from '../../include/DynamicBanner';
import AboutSports from './Partials/AboutSports';
import Achievements from './Partials/Achievements';
import FacilitySection from './Partials/FacilitySection';
import CulturalSection from './Partials/CulturalSection';
import Contact from './Partials/Contact';
import HighlightSports from './Partials/HighlightSports';

const Sports = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async function fetchPage() {
      try {
        const res = await api.get("/api/sitepages/about-us/sports");
        setData(res.data);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching sports page:", err);
        setError("Failed to load Sports page.");
        setIsLoading(false);
      }
    })();
  }, []);

  if (isLoading) return <></>;
  if (error || !data) return <div className="container py-4">Error loading page.</div>;

  const bannerData = data.banner_data || {};
  const groups = data.groups || [];

  // Map groups to named sections (guard with || {})
  const aboutSection = groups[0]?.about_section || null;
  const achievementsSection = groups[1]?.achievements_section || null;
  const facilitySection = groups[2]?.facility_section || null;
  const culturalSection = groups[3]?.cultural_section || null;
  const contactSection = groups[4]?.contact_section || null;
  const highlightsSection = groups[5]?.highlights_section || null;

  return (
    <div className='sportspage-section'>
<DynamicBanner
  title={bannerData.title || "SPORTS"}
  bgImage={Array.isArray(bannerData.images) ? bannerData.images : []}
  bgImageMobile={
    Array.isArray(bannerData.mobile_images)
      ? bannerData.mobile_images
      : []
  }
/>


      {/* Pass down data as props */}
      <AboutSports aboutSection={aboutSection} />
      <Achievements achievementsSection={achievementsSection} />
      <HighlightSports highlightsSection={highlightsSection} />
      <FacilitySection facilitySection={facilitySection} />
      <CulturalSection culturalSection={culturalSection} />
      <Contact contactSection={contactSection} />
    </div>
  );
};

export default Sports;
